export const taskManagementTour = {
    module: 'task_management',
    title: 'Task Management Tour',
    title_vi: 'Tour Quản lý công việc',
    description: 'Route compliance tasks across personas, track SLA deadlines, and automate workflows that keep your team accountable.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Route compliance tasks across personas, track SLA deadlines, and automate workflows that keep your team accountable.',
    estimated_duration_seconds: 75,
    steps: [
        {
            step_id: 'open_tasks',
            navigate_to: '/admin/tasks',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Task Management Overview',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Management Overview',
            description: 'As the Compliance Manager, you will coordinate tasks across DPOs, auditors, and IT leads from this central hub. Every regulatory deadline and remediation action flows through here.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Compliance Manager, you will coordinate tasks across DPOs, auditors, and IT leads from this central hub. Every regulatory deadline and remediation action flows through here.',
            position: 'bottom',
        },
        {
            step_id: 'task_list',
            target: '.dm-table',
            title: 'Task List',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task List',
            description: 'Each row shows the assignee, SLA deadline, priority, and current status so you can spot overdue items before they become audit findings.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each row shows the assignee, SLA deadline, priority, and current status so you can spot overdue items before they become audit findings.',
            position: 'bottom',
        },
        {
            step_id: 'create_task',
            target: '.dm-header .btn-primary',
            title: 'Create a Task',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Task',
            description: 'Click here to create a new compliance task. Tasks can be linked to specific modules like incidents, DPIAs, or vendor reviews.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to create a new compliance task. Tasks can be linked to specific modules like incidents, DPIAs, or vendor reviews.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'task_form',
            target: '.dm-form-modal',
            wait_for: '.dm-form-modal',
            title: 'Task Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Form',
            description: 'Set the priority, regulatory deadline, module link, and assignees. Checklist items let you break complex remediation actions into trackable sub-steps.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set the priority, regulatory deadline, module link, and assignees. Checklist items let you break complex remediation actions into trackable sub-steps.',
            position: 'right',
        },
        {
            step_id: 'fill_task_title',
            target: '[data-testid="task-title"]',
            title: 'Task Title',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Title',
            description: 'Give the task a clear, actionable title that references the regulation or control, so any team member understands the compliance context at a glance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Give the task a clear, actionable title that references the regulation or control, so any team member understands the compliance context at a glance.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="task-title"]',
                value: '[TOUR] Review Q2 DPIA findings',
            },
        },
        {
            step_id: 'assign_task',
            target: '[data-testid="task-assignee"]',
            title: 'Assign the Task',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assign the Task',
            description: 'Route the task to the right persona -- the DPO for privacy reviews, IT Security for technical remediation, or Legal for regulatory interpretation. Assignees receive an immediate notification.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Route the task to the right persona -- the DPO for privacy reviews, IT Security for technical remediation, or Legal for regulatory interpretation. Assignees receive an immediate notification.',
            position: 'bottom',
            action: { type: 'click', target: '[data-testid="task-assignee"]' },
            duration_ms: 100,
        },
        {
            step_id: 'submit_task',
            target: '.dm-modal-footer .dm-btn-primary',
            title: 'Save the Task',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Task',
            description: "Click Save to create the task. It appears in the assignee's queue immediately and the SLA clock starts counting down.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click Save to create the task. It appears in the assignee's queue immediately and the SLA clock starts counting down.",
            position: 'top',
        },
        {
            step_id: 'board_view',
            navigate_to: '/admin/tasks/board',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Kanban Board',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Kanban Board',
            description: 'Visualize task progress across columns. Drag cards between statuses to update them -- ideal for sprint-style compliance remediation tracking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Visualize task progress across columns. Drag cards between statuses to update them -- ideal for sprint-style compliance remediation tracking.',
            position: 'bottom',
        },
        {
            step_id: 'calendar_view',
            navigate_to: '/admin/tasks/calendar',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Calendar View',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Calendar View',
            description: 'Regulatory deadlines and remediation due dates plotted on a monthly calendar, so you never miss an SLA or framework submission window.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Regulatory deadlines and remediation due dates plotted on a monthly calendar, so you never miss an SLA or framework submission window.',
            position: 'bottom',
        },
        {
            step_id: 'my_tasks',
            navigate_to: '/admin/tasks/my',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'My Tasks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: My Tasks',
            description: 'Your personal compliance queue, sorted by priority and SLA urgency. As a DPO or auditor, start here each morning to see what needs attention.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Your personal compliance queue, sorted by priority and SLA urgency. As a DPO or auditor, start here each morning to see what needs attention.',
            position: 'bottom',
        },
        {
            step_id: 'overdue_tasks',
            navigate_to: '/admin/tasks/overdue',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Overdue Tasks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Overdue Tasks',
            description: 'All tasks past their SLA deadline across the organization. As the Compliance Manager, use this view to escalate breached timelines before they become regulatory findings.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All tasks past their SLA deadline across the organization. As the Compliance Manager, use this view to escalate breached timelines before they become regulatory findings.',
            position: 'bottom',
        },
        {
            step_id: 'workflows',
            navigate_to: '/admin/tasks/workflows',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Workflows',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Workflows',
            description: 'Automated workflows trigger tasks when compliance events occur -- a new data breach creates an incident response chain, an overdue DPIA spawns escalation tasks to the DPO.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Automated workflows trigger tasks when compliance events occur -- a new data breach creates an incident response chain, an overdue DPIA spawns escalation tasks to the DPO.',
            position: 'bottom',
        },
        {
            step_id: 'workflow_templates_btn',
            target: '.dm-header button:first-child',
            title: 'Browse Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse Templates',
            description: 'Click here to browse pre-built workflow templates for common regulatory scenarios like GDPR breach notification or annual DPIA review cycles.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to browse pre-built workflow templates for common regulatory scenarios like GDPR breach notification or annual DPIA review cycles.',
            position: 'bottom',
        },
        {
            step_id: 'create_workflow_btn',
            target: '.dm-header button:last-child',
            title: 'Create a Workflow',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Workflow',
            description: "Click here to build a custom workflow with steps, transitions, and escalation rules tailored to your organization's compliance processes.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to build a custom workflow with steps, transitions, and escalation rules tailored to your organization's compliance processes.",
            position: 'bottom',
        },
        {
            step_id: 'workflow_template_catalog',
            navigate_to: '/admin/tasks/workflows/templates',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Workflow Template Catalog',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Workflow Template Catalog',
            description: 'Pre-built templates cover GDPR Article 33 breach notification, vendor reassessment, DPIA review, and more. Click Install to activate a template instantly.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Pre-built templates cover GDPR Article 33 breach notification, vendor reassessment, DPIA review, and more. Click Install to activate a template instantly.',
            position: 'bottom',
        },
        {
            step_id: 'workflow_new',
            navigate_to: '/admin/tasks/workflows',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Workflow Builder',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Workflow Builder',
            description: 'Define the workflow name, applicable task types, assignment strategy, SLA hours, and configure steps and transitions to match your regulatory response procedures.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the workflow name, applicable task types, assignment strategy, SLA hours, and configure steps and transitions to match your regulatory response procedures.',
            position: 'bottom',
        },
        {
            step_id: 'tasks_complete',
            target: '.dm-page',
            title: 'Task Management Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Management Tour Complete',
            description: 'You can now route compliance tasks across your team, track SLA deadlines, and automate workflows that produce auditable evidence of timely response.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now route compliance tasks across your team, track SLA deadlines, and automate workflows that produce auditable evidence of timely response.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=task-management.js.map